export default __webpack_public_path__ + "static/media/Icon.451dd4da.svg";